// Generic JSON-serialised localStorage read/write helpers.
//
// Reads return the parsed JSON value or `defaultValue` when the key is
// absent or the stored payload cannot be parsed. Writes JSON-stringify
// the value. Both helpers swallow exceptions (Safari private mode,
// quota exceeded, disabled storage) and warn in non-production so a
// flaky storage layer cannot break the surrounding UI.

const warn = (message) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(message);
  }
};

export const getLocalStorageValue = (key, defaultValue) => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (e) {
    warn(`Failed to read localStorage key "${key}": ${e.message}`);
    return defaultValue;
  }
};

export const setLocalStorageValue = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    warn(`Failed to write localStorage key "${key}": ${e.message}`);
  }
};
